import { useMemo } from "react";
import { FiArrowRight } from "react-icons/fi";
import { ROUTES } from "src/constants";
import { usePatientSelfSchedulingContext } from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";

interface IProps {
    setRoute: (newRoute: string) => void;
}

const PatientSchedulingSideBar: React.FC<IProps> = ({ setRoute }) => {
    const { selfScheduleSettings, selfSchedule, practitioners, route } =
        usePatientSelfSchedulingContext();

    //TODO LOBBIE-3374, same as other
    if (!selfSchedule || !selfScheduleSettings) return null;

    const practitionerDisplay = useMemo(() => {
        return practitioners?.find((p) => p.id === selfSchedule.practitionerId);
    }, [practitioners, selfSchedule.practitionerId]);

    const stepName = useMemo(() => {
        if (route === ROUTES.patientSchedulingApptType)
            return selfScheduleSettings.appointmentPatientFieldName + " Type";
        if (route === ROUTES.patientSchedulingLocation) return "Location";
        if (route === ROUTES.patientSchedulingPractitioner)
            return selfScheduleSettings.practitionerFieldName || "Practitioner";
        if (route === ROUTES.patientSchedulingCalendar) return "Date & Time";
        return "Appointment Type";
    }, [
        route,
        selfScheduleSettings?.appointmentPatientFieldName,
        selfScheduleSettings?.practitionerFieldName,
    ]);

    const currentStep = useMemo(() => {
        return (
            <div className="bg-white border border-primary rounded p-3 my-2">
                <div className="bold blue">
                    <FiArrowRight />
                    {stepName}
                </div>
                <div className="semi-bold gray2 ml-3 mt-1 body-small">Select {stepName}</div>
            </div>
        );
    }, [stepName]);

    return (
        <div className="bg-gray5 border rounded p-3 h-100">
            {selfScheduleSettings.welcomeMessageTitle && (
                <div>
                    <div className="header-xlarge bold mb-3">
                        {selfScheduleSettings.welcomeMessageTitle}
                    </div>
                    {selfScheduleSettings.welcomeMessageSubtitle && (
                        <div className="semi-bold mb-3">
                            {selfScheduleSettings.welcomeMessageSubtitle}
                        </div>
                    )}
                </div>
            )}
            {selfScheduleSettings.appointmentTypeVisible &&
                selfSchedule.appointmentType &&
                route !== ROUTES.patientSchedulingApptType && (
                    <div
                        className="border-bottom mx-3 mb-3"
                        onClick={() => setRoute(ROUTES.patientSchedulingApptType)}
                    >
                        <div className="semi-bold gray2">Appointment Type</div>
                        <div className="mt-2 mb-2 semi-bold body-small">
                            {selfSchedule.appointmentType.name}
                        </div>
                    </div>
                )}
            {selfSchedule.appointmentType && route === ROUTES.patientSchedulingApptType && (
                <>{currentStep}</>
            )}
            {selfScheduleSettings.locationVisible && selfSchedule.location && (
                <div className="border-bottom mx-3 mb-3">
                    <div className="semi-bold gray2">Location</div>
                    <div className="mt-2 mb-2 semi-bold body-small">
                        {selfSchedule.location.name}
                    </div>
                </div>
            )}
            {selfSchedule.practitionerId && practitionerDisplay && (
                <div className="border-bottom mx-3">
                    <div className="semi-bold gray2">
                        {selfScheduleSettings.practitionerFieldName}
                    </div>
                    <div className="mt-2 mb-2 semi-bold body-small">
                        {practitionerDisplay.displayName}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PatientSchedulingSideBar;
